// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-reforma{
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  gap: 20px;
}

.container-search-bar{
  display: flex;
  align-items: center;
  justify-content: center;
}

.left-column{
  width: 50%;
  display: flex;
  flex-direction: column;
  min-width: 550px;
}

.right-column{
  width: 50%;
  display: flex;
  flex-direction: column;
  min-width: 550px;
}

.container-reforma-mobile{
  display: flex;
  align-items: center;
  flex-direction: column;
}

.container-my-reforms {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 20px;
    padding-right: 20px;
    color: var(--text);
}

.container-sort{
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.sort{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-right: 60px;
  margin-top: 28px;
}

.sort mat-icon,
.sort-span{
  cursor: pointer;
}

.sort span{
  font-size: 14px;
}

.sort-span{
  font-weight: 700;
  padding-left: 20px;
  padding-right: 10px;
}

.reform-wrapper {
    max-width: 600px;
    width: 100%;
    display: flex;
    gap: 20px;
    margin: 14px 0;
    align-self: center;
    border-radius: 16px;
    border: 1px solid #fff;
    background-color: var(--screen-background);
    box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.15);
    padding: 16px;
}

.wrap-content {
    display: flex;
    flex-direction: row;
    width: 100%;
}


.title {
    color: var(--text);
    text-align: center;
    padding: 28px 20px;
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

}

.container-list-name {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.content-list-name {
    width: -moz-fit-content;
    width: fit-content;
    padding-right: 15px;
    padding-left: 15px;
}

.content-list-name p{
  color: var(--text);
}

.list-title {
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.last-edition {
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.action-btn {
    width: 115px;
    height: 28px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 82px;
    background-color: var(--primary-background);

    color: var(--primary-font);
    font-size: 14px;
    font-weight: 500;
  }

.details {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.container-detail span, .details span{
  color: var(--text) !important;
}

.container-detail {
    display: flex;
    justify-content: space-around;
    width: 100%;
}

.container-detail span{
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding-bottom: 10px;
    width: 50%;
}

.detail-info-span{
    font-weight: 600 !important;
    text-transform: lowercase;
}

.label-price{
    font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.price {
    color: var(--07, #2CA900);
    font-family: Roboto;
    font-size: 16.509px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.lead-resume-search{
  max-width: 500px;
  width: 100%;
  min-width: 250px;
  margin: auto;
}


#page {
    display: grid;
    width: 100%;
    height: auto;
    grid-template-areas:
        "main foot"
        "nav foot";
    grid-template-rows: auto 2fr;
    grid-template-columns: 40% 1fr;
}

img {
    grid-area: nav;
    max-width: 100%;
    height: -moz-fit-content;
    height: fit-content;
    border-radius: 8px;
}

#page>main {
    grid-area: main;
    padding: 16px;
    box-sizing: border-box;
}

#page>footer {
    grid-area: foot;
    padding: 16px;
}

.spinner-container {
  display: grid;
  justify-content: center;
}

@media screen and (max-width: 1279px) {
  .container-sort{
    max-width: 600px;
  }
}

@media screen and (max-width: 768px) {

  .title {
    padding: 20px;
  }

    #page {
        grid-template-areas: "nav main" "foot foot";
    }

    #page footer {
        padding: 0;
        margin-top: 10px;
    }

    .details {
        padding-left: 0;
    }

    .container-detail span {
        font-size: 12px;
    }

    .label-price{
        font-size: 9px;
    }

    .list-title {
        font-size: 14px;
    }

    .last-edition {
        font-size: 10px;
    }

    .wrap-content {
        flex-direction: column;
    }

    .container-list-name {
        flex-wrap: wrap;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/lead-resume/lead-resume.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,0CAA0C;IAC1C,+CAA+C;IAC/C,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;;AAGA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;;IAEZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,mBAAmB;IACnB,2CAA2C;;IAE3C,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;EAClB;;AAEF;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;;AAGA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ;;kBAEc;IACd,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,wBAAmB;IAAnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE;IACE,aAAa;EACf;;IAEE;QACI,2CAA2C;IAC/C;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".container-reforma{\n  display: flex;\n  max-width: 1200px;\n  margin: 0 auto;\n  gap: 20px;\n}\n\n.container-search-bar{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.left-column{\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  min-width: 550px;\n}\n\n.right-column{\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  min-width: 550px;\n}\n\n.container-reforma-mobile{\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.container-my-reforms {\n    margin-top: 30px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-left: 20px;\n    padding-right: 20px;\n    color: var(--text);\n}\n\n.container-sort{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.sort{\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n  margin-right: 60px;\n  margin-top: 28px;\n}\n\n.sort mat-icon,\n.sort-span{\n  cursor: pointer;\n}\n\n.sort span{\n  font-size: 14px;\n}\n\n.sort-span{\n  font-weight: 700;\n  padding-left: 20px;\n  padding-right: 10px;\n}\n\n.reform-wrapper {\n    max-width: 600px;\n    width: 100%;\n    display: flex;\n    gap: 20px;\n    margin: 14px 0;\n    align-self: center;\n    border-radius: 16px;\n    border: 1px solid #fff;\n    background-color: var(--screen-background);\n    box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.15);\n    padding: 16px;\n}\n\n.wrap-content {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n}\n\n\n.title {\n    color: var(--text);\n    text-align: center;\n    padding: 28px 20px;\n    font-family: Roboto;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n\n}\n\n.container-list-name {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n}\n\n.content-list-name {\n    width: fit-content;\n    padding-right: 15px;\n    padding-left: 15px;\n}\n\n.content-list-name p{\n  color: var(--text);\n}\n\n.list-title {\n    font-family: Roboto;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n}\n\n.last-edition {\n    font-family: Roboto;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.action-btn {\n    width: 115px;\n    height: 28px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    border-radius: 82px;\n    background-color: var(--primary-background);\n\n    color: var(--primary-font);\n    font-size: 14px;\n    font-weight: 500;\n  }\n\n.details {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n.container-detail span, .details span{\n  color: var(--text) !important;\n}\n\n.container-detail {\n    display: flex;\n    justify-content: space-around;\n    width: 100%;\n}\n\n.container-detail span{\n    font-family: Roboto;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    padding-bottom: 10px;\n    width: 50%;\n}\n\n.detail-info-span{\n    font-weight: 600 !important;\n    text-transform: lowercase;\n}\n\n.label-price{\n    font-family: Roboto;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.price {\n    color: var(--07, #2CA900);\n    font-family: Roboto;\n    font-size: 16.509px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n}\n\n.lead-resume-search{\n  max-width: 500px;\n  width: 100%;\n  min-width: 250px;\n  margin: auto;\n}\n\n\n#page {\n    display: grid;\n    width: 100%;\n    height: auto;\n    grid-template-areas:\n        \"main foot\"\n        \"nav foot\";\n    grid-template-rows: auto 2fr;\n    grid-template-columns: 40% 1fr;\n}\n\nimg {\n    grid-area: nav;\n    max-width: 100%;\n    height: fit-content;\n    border-radius: 8px;\n}\n\n#page>main {\n    grid-area: main;\n    padding: 16px;\n    box-sizing: border-box;\n}\n\n#page>footer {\n    grid-area: foot;\n    padding: 16px;\n}\n\n.spinner-container {\n  display: grid;\n  justify-content: center;\n}\n\n@media screen and (max-width: 1279px) {\n  .container-sort{\n    max-width: 600px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n\n  .title {\n    padding: 20px;\n  }\n\n    #page {\n        grid-template-areas: \"nav main\" \"foot foot\";\n    }\n\n    #page footer {\n        padding: 0;\n        margin-top: 10px;\n    }\n\n    .details {\n        padding-left: 0;\n    }\n\n    .container-detail span {\n        font-size: 12px;\n    }\n\n    .label-price{\n        font-size: 9px;\n    }\n\n    .list-title {\n        font-size: 14px;\n    }\n\n    .last-edition {\n        font-size: 10px;\n    }\n\n    .wrap-content {\n        flex-direction: column;\n    }\n\n    .container-list-name {\n        flex-wrap: wrap;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
